import * as sup from "superstruct";

import { createResourceStruct } from "@/modules/api/utils/jsonApiStructs";

import { takenTestQuestionSingleIdentifierStruct } from "./takenTestQuestionSingleIdentifierStruct";

export const takenTestQuestionSingleResourceStruct = createResourceStruct({
  identifier: takenTestQuestionSingleIdentifierStruct,
  attributes: sup.object({
    content: sup.string(),
    answers: sup.array(sup.string()),
  }),
});

export type TakenTestQuestionSingleResourceType = sup.Infer<
  typeof takenTestQuestionSingleResourceStruct
>;
